import { fork } from 'redux-saga/effects';

import { actions, selectors } from 'domain/coupon';
import { listNavigator } from 'sagas/common';
import { filters } from 'filters/coupon';

export default function* navigator() {
  yield fork(listNavigator, { modelName: 'Coupon', actions, selectors, filters } );
}
